var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 8.3125C16.125 8.56114 16.0262 8.7996 15.8504 8.97541C15.6746 9.15123 15.4361 9.25 15.1875 9.25H9.25V15.1875C9.25 15.4361 9.15123 15.6746 8.97541 15.8504C8.7996 16.0262 8.56114 16.125 8.3125 16.125C8.06386 16.125 7.8254 16.0262 7.64959 15.8504C7.47377 15.6746 7.375 15.4361 7.375 15.1875V9.25H1.4375C1.18886 9.25 0.950403 9.15123 0.774587 8.97541C0.598772 8.7996 0.5 8.56114 0.5 8.3125C0.5 8.06386 0.598772 7.8254 0.774587 7.64959C0.950403 7.47377 1.18886 7.375 1.4375 7.375H7.375V1.4375C7.375 1.18886 7.47377 0.950403 7.64959 0.774587C7.8254 0.598772 8.06386 0.5 8.3125 0.5C8.56114 0.5 8.7996 0.598772 8.97541 0.774587C9.15123 0.950403 9.25 1.18886 9.25 1.4375V7.375H15.1875C15.4361 7.375 15.6746 7.47377 15.8504 7.64959C16.0262 7.8254 16.125 8.06386 16.125 8.3125Z",
    fill: "#3F526E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.d023a2b3414abc0123a39e7dd9b05bc7.svg";
export { ForwardRef as ReactComponent };